import * as LocalStorage from "./localStorage";
import {redirect} from "react-router-dom";
const isAuth = ({ isProtected }) => {
    const userInfo = LocalStorage.getLSValue("user");
    if (isProtected) {
      if (!userInfo) {
        return null;
      } else {
        return redirect("/dashboard");
      }
    }
    if (userInfo) {
      return null;
    } else {
      return redirect("/");
    }
  };

  export default isAuth